// Akıllı Depo Tanımlama (WMS) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.warehouseSetup';

export const wmsWarehouseSetupGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Akıllı Depo Tanımlama nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Akıllı depo (WMS) tüm mal kabul, yerleştirme, toplama ve sayım işlerinin temelidir. Burada depoyu tanımlar, sonra lokasyonlarını (bölge, koridor, peron, raf) kurarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve Yeni Depo Ekle'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    table: t(`${G}.regions.table`, 'Akıllı depo listesi'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Kartlar tüm akıllı depolarınızın toplamını gösterir: Toplam Stok Miktarı ve Ürün Çeşidi (yalnız miktarı sıfırdan büyük stoklar sayılır), Aktif Akıllı Depo (aktif / toplam) ve Aktif Lokasyon (aktif / toplam).'),
    },
    {
      region: 'header',
      title: t(`${G}.s2.title`, '2. Yeni depo ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni Depo Ekle" (liste boşsa "İlk Depoyu Ekle") pencereyi açar. Depo Adı ve Lokasyon Modeli zorunludur; adres, telefon, sorumlu kişi, şube ve kapasite isteğe bağlıdır. Ayrıntılar pencerenin kendi (i) rehberindedir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Listeyi okuyun'),
      text: t(`${G}.s3.text`, 'Her satırda Depo Adı, Lokasyon Modeli (3 Seviye / 5 Seviye), Rota Stratejisi, lokasyon sayısı ve durum (Aktif / Pasif) görünür. Satıra tıklamak depoyu düzenleme penceresinde açar.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Lokasyonları kurun'),
      text: t(`${G}.s4.text`, 'Satırdaki harita simgesi ("Lokasyonları Yönet", mobilde "Lokasyonlar") deponun Lokasyon Yönetimi sayfasını açar. Orada 2D haritada bölge, koridor, peron ve rafları çizer ya da ağaç görünümünde lokasyonları tek tek eklersiniz. Akıllı depoda yerleştirme ve toplama raf lokasyonları üzerinden yürür; bu yüzden önce lokasyonları kurun.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Düzenleyin veya silin'),
      text: t(`${G}.s5.text`, 'Kalem simgesi depoyu düzenler; düzenleme penceresinde ayrıca açık pazaryeri kanalları ve otomatik WMS aktarımı ayarlanır. Çöp kutusu simgesi depoyu siler.'),
      tips: [
        t(`${G}.s5.tip1`, 'Lokasyonu olan bir depo silinemez; önce lokasyonlarını silin.'),
        t(`${G}.s5.tip2`, 'Silme işlemi geri alınamaz.'),
      ],
    },
  ],
});
